import * as React from "react"

import type { NamedRoutes } from "shared/utils/routes"

import Deals from "./Deals"
import Options from "./Options"
import Skus from "./Skus"

export const namedRoutes: NamedRoutes = {
  skus: {
    pathTemplate: "grid/skus",
    element: <Skus />,
  },
  sku: {
    pathTemplate: "grid/skus/:skuId",
    element: <Skus />,
  },
  options: {
    pathTemplate: "grid/options",
    element: <Options />,
  },
  option: {
    pathTemplate: "grid/options/:optionId",
    element: <Options />,
  },
  deals: {
    pathTemplate: "grid/deals",
    element: <Deals />,
  },
  deal: {
    pathTemplate: "grid/deals/:dealId",
    element: <Deals />,
  },
}
